import './email-element.scss';

export default {
  group: 'form-group',
  inputWrapper: '',
  input: 'form-control email-input',
  label: 'label-override',
  requiredIndicator: 'required-indicator',
}



// WEBPACK FOOTER //
// src/common/form-elements/email-element-folder/email-element.style.js